import { render, staticRenderFns } from "./ScreenPacientesLista.vue?vue&type=template&id=158a7174&lang=true&"
import script from "./ScreenPacientesLista.vue?vue&type=script&lang=js&"
export * from "./ScreenPacientesLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports